import React from 'react';
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';


import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import Typography from '@mui/material/Typography';

import RecommendationCard from "../widgets/RecommendationCard";
import ImageCard from "../widgets/ImageCard";


import Stack from '@mui/material/Stack';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';


import Header from "./common/Header2";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'animate.css';


const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  	...theme.typography.body2,
  	padding: theme.spacing(1),
  	textAlign: 'center',
  	color: theme.palette.text.secondary,
}));

function StartContent(props) {
	const { t, i18n } = useTranslation("",{lng: props.language});

  	let navigate = useNavigate(); 


	const callUrl = (url) => {
		navigate(url);
	};
	
	const [anim, setAnim] = React.useState("animate__animated animate__fadeInUp");

	const [ref0, inView0] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref1, inView1] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref2, inView2] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref3, inView3] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref4, inView4] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref5, inView5] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref6, inView6] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref7, inView7] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	const [ref8, inView8] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const hero = [ {
	  	"src": "Slide1HeroVerwaltungPage",
		"headline": t("ImmobilienClaim2"),
		"slogan": "Slogan fehlt hier"
		}
	];


  	return (<>
	  			<Box>
					<Header hero={hero} embedded={props.props.embedded} logo="logo-verwaltung.png"/>

	  			</Box>
				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'none',  
							md: 'none',  
							lg: 'none',  
							xl: 'none',  							
							} }}
				>
					<center>
						<h2 style={{paddingTop: "4px", fontSize: "1.5em"}} class="headlineNewPoint">{t("immobilienverwaltungIntro")}</h2>
					</center>
        			<Grid item xs={12}>
		      			<Grid container spacing={2}>
		        			<Grid item xs={1}>
				     		</Grid>
		        			<Grid item xs={10}>
								<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
									<Box  style={{textAlign: "justify", color: "#000"}}>					
										<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungContent")}</p>
									</Box>			
								</Box>	
				     		</Grid>
		        			<Grid item xs={1}>
				     		</Grid>
			     		</Grid>
		     		</Grid>	
		     		
		     		
					<Grid container style={{paddingTop: "40px", paddingBottom: "20px"}}>
		        		<Grid item xs={12}>
				      		<Grid container spacing={2}>
				        		<Grid item xs={1}>
					     	   </Grid>
				        		<Grid item xs={10}>
									<div class="ps-section__content" style={{marginBottom: "20px"}}>
					        			<span ref={ref1} />
										<div class="ps-block--vendor-milestone">
											<div class="ps-block__left">
												<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP1")}</h2>
												<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
													<Box  style={{textAlign: "justify", color: "#000"}}>					
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent1")}</p>
													</Box>			
												</Box>	

											</div>
											<div class="ps-block__right">
												{inView1 === true ? (<>
													<Box className="animate__animated animate__slideInRight1" style={{textAlign: "left"}}>	
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent1")}</p>																			
													</Box>												
												</>) : (<></>)}												
											</div>
											<div class="ps-block__number">
												<span>1</span>
											</div>
										</div>


										<div class="ps-block--vendor-milestone">
											<div class="ps-block__left">
												<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP2")}</h2>
												<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
													<Box  style={{textAlign: "justify", color: "#000"}}>					
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent2")}</p>
													</Box>			
												</Box>	

											</div>
											<div class="ps-block__right">
												{inView1 === true ? (<>
													<Box className="animate__animated animate__slideInRight1" style={{textAlign: "left"}}>	
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent2")}</p>																			
													</Box>												
												</>) : (<></>)}												
											</div>
											<div class="ps-block__number">
												<span>2</span>
											</div>
										</div>


										<div class="ps-block--vendor-milestone">
											<div class="ps-block__left">
												<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP3")}</h2>
												<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
													<Box  style={{textAlign: "justify", color: "#000"}}>					
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent3")}</p>
													</Box>			
												</Box>	

											</div>
											<div class="ps-block__right">
												{inView1 === true ? (<>
													<Box className="animate__animated animate__slideInRight1" style={{textAlign: "left"}}>	
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent3")}</p>																			
													</Box>												
												</>) : (<></>)}												
											</div>
											<div class="ps-block__number">
												<span>3</span>
											</div>
										</div>

										<div class="ps-block--vendor-milestone">
											<div class="ps-block__left">
												<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP4")}</h2>
												<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
													<Box  style={{textAlign: "justify", color: "#000"}}>					
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent4")}</p>
													</Box>			
												</Box>	

											</div>
											<div class="ps-block__right">
												{inView1 === true ? (<>
													<Box className="animate__animated animate__slideInRight1" style={{textAlign: "left"}}>	
														<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent4")}</p>																			
													</Box>												
												</>) : (<></>)}												
											</div>
											<div class="ps-block__number">
												<span>4</span>
											</div>
										</div>


									</div>
						     	</Grid>

				        		<Grid item xs={1}>
					     	   </Grid>
				     	   </Grid>
			     	   </Grid>
		     	   </Grid>
		     		
		     		
		     		
	  			</Box>



				<Box sx={{ flexGrow: 1, display: {
							xs: 'none',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>

					
					<hr className="spacer"/>
						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "40px"}} class="headlineNewPoint">{t("immobilienverwaltungIntro")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungContent")}</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						<Grid container style={{paddingTop: "40px", paddingBottom: "20px"}}>
			        		<Grid item xs={12}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={1}>
						     	   </Grid>
					        		<Grid item xs={10}>
										<div class="ps-section__content" style={{marginBottom: "20px"}}>
						        			<span ref={ref1} />
											<div class="ps-block--vendor-milestone">
												<div class="ps-block__left">
													<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP1")}</h2>
													<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
														<Box  style={{textAlign: "justify", color: "#000"}}>					
															<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent1")}</p>
														</Box>			
													</Box>	

												</div>
												<div class="ps-block__right">
													{inView1 === true ? (<>
														<Box className="animate__animated animate__slideInRight" style={{textAlign: "left"}}>	
															<ImageCard title={t("immobilienverwaltungUSP1")} slogan="" width="128" image="/assets/abrechnung.jpg" description="tralala"/>																			
														</Box>												
													</>) : (<></>)}												
												</div>
												<div class="ps-block__number">
													<span>1</span>
												</div>
											</div>
						        			<span ref={ref2} />
											<div class="ps-block--vendor-milestone reverse">
												<div class="ps-block__left">
													<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP2")}</h2>
													<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
														<Box  style={{textAlign: "justify", color: "#000"}}>					
															<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent2")}</p>
														</Box>			
													</Box>
												</div>
												<div class="ps-block__right">
													{inView2 === true ? (<>
														<Box className="animate__animated animate__slideInLeft" style={{textAlign: "left"}}>	
																<Stack direction="row" spacing={2}>	
																	<RecommendationCard title="Heizung Sanitär" slogan="Firma Doetsch" width="48" image="/assets/doetsch.png" description="Alles rund im Ihre Heizung"/>																			
																	<RecommendationCard title="Tischlerei" slogan="Firma Nengel" width="48" image="/assets/negel.png" description="Wir machen in Holz"/>																			
																	<RecommendationCard title="Sanitär Heiztechnik" slogan="Joachim Krech" width="48" image="/assets/krech.png" description="Wir sorgen für Wärme"/>																			
																	<RecommendationCard title="Dachdecker" slogan="Joachim Krech" width="48" image="/assets/martin.png" description="Wir sorgen für Wärme"/>																			
																</Stack>
														</Box>												
													</>) : (<></>)}												
												</div>
												<div class="ps-block__number">
													<span>2</span>
												</div>
											</div>
						        			<span ref={ref3} />
											<div class="ps-block--vendor-milestone">
												<div class="ps-block__left">
													<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP3")}</h2>
													<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
														<Box  style={{textAlign: "justify", color: "#000"}}>					
															<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent3")}</p>
														</Box>			
													</Box>												

												</div>
												<div class="ps-block__right">
													{inView3 === true ? (<>
														<Box className="animate__animated animate__slideInRight" style={{textAlign: "left"}}>	
															<ImageCard title={t("immobilienverwaltungUSP1")} slogan="" width="128" image="/assets/betreuung.jpg" description="tralala"/>																			
														</Box>												
													</>) : (<></>)}												
												</div>
												<div class="ps-block__number">
													<span>3</span>
												</div>
											</div>
						        			<span ref={ref4} />
											<div class="ps-block--vendor-milestone reverse">
												<div class="ps-block__left">
													<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP4")}</h2>
														<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
															<Box  style={{textAlign: "justify", color: "#000"}}>					
																<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent4")}</p>
															</Box>			
														</Box>	
												</div>
												<div class="ps-block__right">
													{inView4 === true ? (<>
														<Box className="animate__animated animate__slideInLeft">	
															<ImageCard title="" slogan="" width="128" image="/assets/reaktionszeit.jpg" description=""/>																			
														</Box>												
													</>) : (<></>)}												
												</div>
												<div class="ps-block__number">
													<span>4</span>
												</div>
											</div>
											<span ref={ref5} />
											<div class="ps-block--vendor-milestone">
												<div class="ps-block__left">
													<h2 class="highlightText headlineNewPoint">{t("immobilienverwaltungUSP5")}</h2>
														<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
															<Box  style={{textAlign: "justify", color: "#000"}}>					
																<p class="altFliessText" style={{margin: 0}}>{t("immobilienverwaltungUSPContent5")}</p>
															</Box>			
														</Box>	
									
											</div>
												<div class="ps-block__right">
													{inView5 === true ? (<>
														<Box className="animate__animated animate__slideInRight" style={{textAlign: "left"}}>	
															<ImageCard title="" slogan="" width="128" image="/assets/werterhalt.jpg" description=""/>																			
														</Box>												
													</>) : (<></>)}												
												</div>
												<div class="ps-block__number">
													<span>5</span>
												</div>
											</div>											
											
										</div>											
						     	   	</Grid>
					        		<Grid item xs={1}>
									</Grid>
								</Grid>
							</Grid>
						</Grid>																		


	
		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'block',
																		sm: 'block',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  																		
																		}}}> 
							<Box sx={{paddingTop: "0px"}}>
							</Box>	
		  				
Immobilienverwaltung							
		  				
							

						</Box>
	
						
		

		
	
	   				</Box>
   		</>
   	)
}

export default function StartPage(props) {

  return <StartContent props={props}/>;
}